import { useState } from "react";
import "./index.scss";
import { SidebarFilterItem } from "components/UI/molecules";
import { useNavigate } from "hooks/useCustomNavigation";
import { ReactComponent as ReplyArrowIcon } from "assets/reply-arrow-icon.svg";

const FILTERS_INITIAL_VALUE = {
  discount: "",
  cashback: "",
  card_type: "",
  category: ""
};

export const SidebarFilters = ({ filters, onFilterClick }) => {
  const navigate = useNavigate();
  const [selectedFilters, setFilters] = useState(FILTERS_INITIAL_VALUE);

  const handleFilterClick = (item, type) => {
    const isSpecial = type === "specials";
    const isSelectedFilter =
      selectedFilters[type] === (item.value || item.name);

    if (isSpecial) {
      navigate(item.path);
      return;
    }

    if (isSelectedFilter) {
      setFilters({ ...selectedFilters, [type]: "" });
      onFilterClick(type, "");
      return;
    }

    setFilters({ ...selectedFilters, [type]: item.value || item.name });
    onFilterClick(type, item.value || item.name);
  };

  const filterItems = [
    { title: "Specials", type: "specials" },
    { title: "By Discount", type: "savings" },
    { title: "By GCX Cash", type: "cash_back" },
    { title: "Categories", type: "category" }
  ];

  const hasActiveFilter = Object.values(selectedFilters).some((val) => val);

  if (filters)
    return (
      <div className="sidebar-filters" data-testid="sidebar-filters">
        {hasActiveFilter && (
          <button className="show-all" onClick={() => window.location.reload()}>
            <ReplyArrowIcon />
            Show All Brands
          </button>
        )}
        {filterItems.map(({ title, type }) => (
          <SidebarFilterItem
            key={title}
            title={title}
            type={type}
            items={filters[type]}
            activeFilter={selectedFilters[type]}
            onItemClick={handleFilterClick}
          />
        ))}
      </div>
    );
};
